import { useTranslation } from "react-i18next"
import {
  Button,
  Divider,
  IconButton,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material"
import AddIcon from "@mui/icons-material/Add"
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded"

import usePermissions from "helpers/hooks/usePermissions"
import {
  type AlertSettingEntity,
  useAlertSettingDrawer,
} from "./AlertSettingDrawerContext"

interface NewAlertSettingButtonProps {
  entity: AlertSettingEntity
  entityId: number
}

const NewAlertSettingButton = ({ entity, entityId }: NewAlertSettingButtonProps) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"))
  const { isEditor } = usePermissions()
  const { openCreate } = useAlertSettingDrawer()

  if (!isEditor) return null

  // Icon only on small screens, so it fits in the row of the tabs.
  if (isSmall)
    return (
      <>
        <Divider orientation="vertical" flexItem sx={{ my: 1 }} />
        <Tooltip title={t("alerts.CREATE_ALERT")}>
          <IconButton
            color="primary"
            onClick={() => openCreate(entity, entityId)}
            sx={{ p: 0.5 }}
          >
            <AddCircleOutlineRoundedIcon />
          </IconButton>
        </Tooltip>
      </>
    )

  return (
    <Button
      variant="text"
      size="small"
      startIcon={<AddIcon />}
      onClick={() => openCreate(entity, entityId)}
      sx={{ flexShrink: 0 }}
    >
      {t("alerts.CREATE_ALERT")}
    </Button>
  )
}

export default NewAlertSettingButton
